import { Injectable, inject } from '@angular/core';
import { VwApiRequestsService } from 'vwappservices';

@Injectable({ providedIn: 'root' })
export class ProductsApiService {
  private api = inject(VwApiRequestsService);

  list() {
    return this.api.getAPICall('/products');
  }

  get(id: string) {
    return this.api.getAPICall(`/products/${id}`);
  }

  create(payload: { name: string; nameMr?: string; code: string; description?: string }) {
    return this.api.postAPICall('/products', payload);
  }

  update(id: string, payload: Record<string, any>) {
    return this.api.postAPICall(`/products/${id}`, payload);
  }

  updateMonthlyTargets(id: string, targets: Record<string, number>) {
    return this.api.postAPICall(`/products/${id}/monthly-targets`, { targets });
  }

  delete(id: string) {
    return this.api.postAPICall(`/products/${id}/delete`, {});
  }

  addStep(productId: string, payload: Record<string, any>) {
    return this.api.postAPICall(`/products/${productId}/steps`, payload);
  }

  updateStep(productId: string, stepId: string, payload: Record<string, any>) {
    return this.api.postAPICall(`/products/${productId}/steps/${stepId}`, payload);
  }

  deleteStep(productId: string, stepId: string) {
    return this.api.postAPICall(`/products/${productId}/steps/${stepId}/delete`, {});
  }

  resequenceSteps(productId: string, order: string[]) {
    return this.api.postAPICall(`/products/${productId}/steps/resequence`, { order });
  }

  updateWorkflow(productId: string, payload: { trackingMode?: string | null; steps: { stepId: string; dependencyMode: string; dependsOn: string[] }[] }) {
    return this.api.postAPICall(`/products/${productId}/workflow`, payload);
  }
}
